// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\np[data-v-4eb3813d] {line-height: 1; font-size:13px;}\n", ""]);
// Exports
module.exports = exports;
